export default __webpack_public_path__ + "static/media/url.85534068.svg";